import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import _ from 'lodash';
import { t } from 'utils/translates';

class FilterSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.getVerifiedPropStartValue(),
      titleSelectAll: t('Все')
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.value !== prevState.value) {
      this.props.handleChangeValue(this.state.value);
    }
  }

  getVerifiedPropStartValue = () => {
    const searchVal = this.props.options.find(
      i => i.value === this.props.startValue
    );
    if (searchVal) {
      return this.props.startValue;
    }
    return null;
  };

  getSelectValueTitle = () => {
    if (this.state.value === null) {
      return this.props.titleSelectAll;
    }
    return this.props.options.find(i => i.value === this.state.value).title;
  };

  changeValue = async (event, newValue) => {
    event.preventDefault();
    this.setState({ value: newValue });
  };

  render() {
    return (
      <React.Fragment>
        <button
          type="button"
          className="btn btn-default dropdown-toggle"
          data-toggle="dropdown"
          title={this.props.titleSelectAll}
          aria-expanded="false"
        >
          {this.getSelectValueTitle()}
        </button>
        <ul className="dropdown-menu" role="menu">
          <li className={this.state.value === null ? 'active' : ''}>
            <a href="" onClick={e => this.changeValue(e, null)}>
              {this.props.titleSelectAll}
            </a>
          </li>
          {this.props.options.map(pointsTypeItem => (
            <li
              key={`FilterSelect${pointsTypeItem.value}`}
              className={
                this.state.value === pointsTypeItem.value ? 'active' : ''
              }
            >
              <a
                href=""
                onClick={e => this.changeValue(e, pointsTypeItem.value)}
              >
                {pointsTypeItem.title}
              </a>
            </li>
          ))}
        </ul>
      </React.Fragment>
    );
  }
}

FilterSelect.defaultProps = {
  titleSelectAll: 'Все',
  options: [{ value: 1, title: 'Value1' }, { value: 2, title: 'Value2' }],
  startValue: null
};

FilterSelect.propTypes = {
  // IN
  titleSelectAll: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape),
  startValue: PropTypes.number,
  handleChangeValue: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  userPointsTypes: _.sortBy(
    getItemFromRefList(state, 'userFlowFundsTypesTransactionNew'),
    'title'
  )
});

export default withRouter(connect(mapStateToProps)(FilterSelect));



// WEBPACK FOOTER //
// ./src/components/Common/Inputs/FilterSelect/FilterSelect.js